import {
  ADD_TRIVIA_CHALLENGE,
  ADD_TRIVIA_CHALLENGE_FAILED,
  ADD_TRIVIA_CHALLENGE_SUCCESS,
  DELETE_TRIVIA_CHALLENGE,
  DELETE_TRIVIA_CHALLENGE_FAILED,
  DELETE_TRIVIA_CHALLENGE_SUCCESS,
  GET_TRIVIA_CHALLENGE,
  GET_TRIVIA_CHALLENGE_FAILED,
  GET_TRIVIA_CHALLENGE_LIST,
  GET_TRIVIA_CHALLENGE_LIST_FAILED,
  GET_TRIVIA_CHALLENGE_LIST_SUCCESS,
  GET_TRIVIA_CHALLENGE_SUCCESS,
  GET_TRIVIA_REPLY,
  GET_TRIVIA_REPLY_FAILED,
  GET_TRIVIA_REPLY_SUCCESS,
  HIDE_DELETE_TRIVIA_MODAL,
  OPEN_DELETE_TRIVIA_MODAL,
  RESET_TRIVIA_CHALLENGE,
  RESET_TRIVIA_LIST,
  RESET_TRIVIA_REPLY,
  UPDATE_TRIVIA_CHALLENGE,
  UPDATE_TRIVIA_CHALLENGE_FAILED,
  UPDATE_TRIVIA_CHALLENGE_SUCCESS,
  UPDATE_TRIVIA_LIST_ITEM,
  UPDATE_TRIVIA_LIST_ITEM_FAILED,
  UPDATE_TRIVIA_LIST_ITEM_SUCCESS,
  UPDATE_TRIVIA_ORDER,
  UPDATE_TRIVIA_ORDER_FAILED,
  UPDATE_TRIVIA_ORDER_SUCCESS,
} from "./actionTypes"

export const addTriviaChallenge = params => ({
  type: ADD_TRIVIA_CHALLENGE,
  payload: params,
})

export const addTriviaChallengeSuccess = response => ({
  type: ADD_TRIVIA_CHALLENGE_SUCCESS,
  payload: response,
})

export const addTriviaChallengeFailed = error => ({
  type: ADD_TRIVIA_CHALLENGE_FAILED,
  payload: error,
})

export const getTriviaChallenge = params => ({
  type: GET_TRIVIA_CHALLENGE,
  payload: params,
})

export const getTriviaChallengeSuccess = response => ({
  type: GET_TRIVIA_CHALLENGE_SUCCESS,
  payload: response,
})

export const getTriviaChallengeFailed = error => ({
  type: GET_TRIVIA_CHALLENGE_FAILED,
  payload: error,
})

export const resetTriviaChallenge = () => ({
  type: RESET_TRIVIA_CHALLENGE,
  payload: {},
})

export const updateTriviaChallenge = params => ({
  type: UPDATE_TRIVIA_CHALLENGE,
  payload: params,
})

export const updateTriviaChallengeSuccess = response => ({
  type: UPDATE_TRIVIA_CHALLENGE_SUCCESS,
  payload: response,
})

export const updateTriviaChallengeFailed = error => ({
  type: UPDATE_TRIVIA_CHALLENGE_FAILED,
  payload: error,
})

export const getTriviaChallengeList = params => ({
  type: GET_TRIVIA_CHALLENGE_LIST,
  payload: params,
})

export const getTriviaChallengeListSuccess = response => ({
  type: GET_TRIVIA_CHALLENGE_LIST_SUCCESS,
  payload: response,
})

export const getTriviaChallengeListFailed = error => ({
  type: GET_TRIVIA_CHALLENGE_LIST_FAILED,
  payload: error,
})

export const resetTriviaList = () => ({
  type: RESET_TRIVIA_LIST,
  payload: {},
})

export const openDeleteTriviaModal = () => ({
  type: OPEN_DELETE_TRIVIA_MODAL,
  payload: {},
})

export const hideDeleteTriviaModal = () => ({
  type: HIDE_DELETE_TRIVIA_MODAL,
  payload: {},
})

export const deleteTriviaChallenge = params => ({
  type: DELETE_TRIVIA_CHALLENGE,
  payload: params,
})

export const deleteTriviaChallengeSuccess = response => ({
  type: DELETE_TRIVIA_CHALLENGE_SUCCESS,
  payload: response,
})

export const deleteTriviaChallengeFailed = error => ({
  type: DELETE_TRIVIA_CHALLENGE_FAILED,
  payload: error,
})

export const updateTriviaListItem = params => ({
  type: UPDATE_TRIVIA_LIST_ITEM,
  payload: params,
})

export const updateTriviaListItemSuccess = response => ({
  type: UPDATE_TRIVIA_LIST_ITEM_SUCCESS,
  payload: response,
})

export const updateTriviaListItemFailed = error => ({
  type: UPDATE_TRIVIA_LIST_ITEM_FAILED,
  payload: error,
})

export const updateTriviaOrder = params => ({
  type: UPDATE_TRIVIA_ORDER,
  payload: params,
})

export const updateTriviaOrderSuccess = response => ({
  type: UPDATE_TRIVIA_ORDER_SUCCESS,
  payload: response,
})

export const updateTriviaOrderFailed = error => ({
  type: UPDATE_TRIVIA_ORDER_FAILED,
  payload: error,
})

export const getTriviaReply = params => ({
  type: GET_TRIVIA_REPLY,
  payload: params,
})

export const getTriviaReplySuccess = response => ({
  type: GET_TRIVIA_REPLY_SUCCESS,
  payload: response,
})

export const getTriviaReplyFailed = error => ({
  type: GET_TRIVIA_REPLY_FAILED,
  payload: error,
})

export const resetTriviaReply = () => ({
  type: RESET_TRIVIA_REPLY,
  payload: {},
})
